export default __webpack_public_path__ + "static/media/networker.b2041946.png";